import React, { useEffect, useState } from 'react';
import { Checkbox, Form, Space, Tooltip } from 'antd';
import { RadioCheckboxGroupWrapper, RowLabel, StyledDivider } from './styled';
import { MetricRowProps } from '../types';
import { getSeverityMap } from '../../utils';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import Highlight from '@src/components/common/Highlight';
import { useSelector } from 'react-redux';
import { isAdminRoleSelector } from '@src/store/common/selectors';

const MetricRow = ({
  metricKey,
  metricLabel,
  form,
  searchText,
  metricSeverity: initialMetricSeverity,
}: MetricRowProps) => {
  const product = window.conviva.module;
  // severity value
  const [checked, setChecked] = useState(initialMetricSeverity);
  const isAdminUser = useSelector(isAdminRoleSelector);

  useEffect(() => {
    if (!initialMetricSeverity) {
      setChecked(initialMetricSeverity);
    }
  }, [initialMetricSeverity]);

  const onChange = (e) => {
    if (e.target.value !== checked) {
      setChecked(e.target.value);
    } else {
      setChecked(null);
    }
  };

  useEffect(() => {
    form.setFieldValue(['metricList', metricKey], {
      severity: checked,
    });
  }, [checked, form, metricKey]);

  const severityMap = getSeverityMap()[product];

  return (
    <>
      <Space>
        <RowLabel>
          {searchText ? <Highlight text={metricLabel} highlight={searchText} /> : metricLabel}
        </RowLabel>
        <Form.Item name={['metricList', metricKey, 'severity']} style={{ margin: '10px 0' }}>
          <RadioCheckboxGroupWrapper>
            <Checkbox.Group
              className="radio-checkbox-group"
              value={(checked ? [checked] : []) as CheckboxValueType[]}
            >
              {severityMap.map(({ value, label }) => (
                <Checkbox
                  key={value}
                  value={value}
                  onChange={onChange}
                  style={isAdminUser ? {} : { cursor: 'not-allowed' }}
                >
                  {isAdminUser ? (
                    <Tooltip title={value === checked ? 'Click to unselect' : ''}>{label}</Tooltip>
                  ) : (
                    label
                  )}
                </Checkbox>
              ))}
            </Checkbox.Group>
          </RadioCheckboxGroupWrapper>
        </Form.Item>
      </Space>
      <StyledDivider />
    </>
  );
};

export default MetricRow;
